import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Dropdown,
} from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
const defaultAvatar = require("../../../../../assets/img/avatar-placeholder.png");
import Avatar from "react-avatar";
import "./sidebar.css";
import {
    HUMAN_RESOURCES,
    ROLE_ADMIN,
    ROLE_ADMIN_STATION,
    ROLE_CABIN_ATTENDANT,
    ROLE_STATION_BOSS,
} from "../../../../utility/constants";

import qr_code from "../../../../../assets/img/qr.svg";
import qr_code_white from "../../../../../assets/img/qrblanco.svg";
import { hasPermission } from "../../Utils/PermissionHandler";
import { APP_VERSION } from "../../../../version";

const SideBar = (props) => {
    const {
        toggleOpen,
        navToggle,
        logOut,
        user,
        url,
        showButtons,
        navMenu,
        burgerMenu,
    } = props;
    console.log("SideBar User Role:", user ? user.role : 'No User');
    const [dropdownUserOpen, setDropdownUserOpen] = useState(false);
    const [showPredictive, setShowPredictive] = useState(false);

    let urlValidate = url.includes("/human_resources/");
    let urlValidateReport = url.includes("/report/");

    const styleActive = {
        backgroundColor: "rgba(26, 75, 189, 0.08)",
        color: "#1a4bbd",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "30px",
        fontWeight: "bold"
    };

    const styleInactive = {
        backgroundColor: "transparent",
        color: "#6c757d",
        marginRight: "10px",
        marginBottom: "10px",
        textAlign: "left"
    };

    const [validate, setValidate] = useState(false);
    const [styleDrop, setStyleDrop] = useState(styleInactive);
    const [validateReport, setValidateReport] = useState(false);
    const [styleDropReport, setStyleDropReport] = useState(styleInactive);
    let dropdown = document.getElementsByClassName("dropdown-btn");
    let dropdown_report = document.getElementsByClassName(
        "dropdown-btn-reporting"
    );
    useEffect(() => {
        let i;

        for (i = 0; i < dropdown.length; i++) {
            dropdown[i].addEventListener("click", function () {
                this.classList.toggle("active");
                let dropdownContent = this.nextElementSibling;
                if (dropdownContent.style.display === "block") {
                    dropdownContent.style.display = "none";
                    setValidate(false);
                    setStyleDrop(styleInactive);
                } else {
                    dropdownContent.style.display = "block";
                    dropdownContent.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                    setValidate(true);
                    setStyleDrop(styleActive);
                }
            });
        }

        for (i = 0; i < dropdown_report.length; i++) {
            dropdown_report[i].addEventListener("click", function () {
                this.classList.toggle("active");
                let dropdownContent = this.nextElementSibling;
                if (dropdownContent.style.display === "block") {
                    dropdownContent.style.display = "none";
                    setValidateReport(false);
                    setStyleDropReport(styleInactive);
                } else {
                    dropdownContent.style.display = "block";
                    dropdownContent.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                    setValidateReport(true);
                    setStyleDropReport(styleActive);
                }
            });
        }
    }, []);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key.toLowerCase() === 'q') {
                e.preventDefault();
                setShowPredictive(prev => !prev);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    useEffect(() => {
        validate
            ? setStyleDrop(styleActive)
            : urlValidate
                ? setStyleDrop(styleActive)
                : setStyleDrop(styleInactive);

        validateReport
            ? setStyleDropReport(styleActive)
            : urlValidateReport
                ? setStyleDropReport(styleActive)
                : setStyleDropReport(styleInactive);
    }, [url, validate, validateReport]);

    return (
        <React.Fragment>
            <aside
                className={` main-sidebar px-0 col-12 col-md-3 col-lg-2 ${toggleOpen ? "" : "open"
                    }`}
                style={{ display: !burgerMenu && "none" }}
            >
                <div className="sidebar-header" style={{ backgroundColor: "#ffffff", padding: "30px 20px" }}>
                    <nav
                        className="align-items-stretch flex-md-nowrap mb-2 p-0"
                        style={{ backgroundColor: "#ffffff" }}
                    >
                        <div
                            className="navbar d-flex justify-content-start"
                            style={{ marginBottom: "10px" }}
                        >
                            <a
                                className="text-primary d-flex align-items-center justify-content-center"
                                type="button"
                                onClick={showButtons ? navToggle : navMenu}
                                style={{
                                    width: "35px",
                                    height: "35px",
                                    borderRadius: "10px",
                                    border: "2px solid #f0f2f5",
                                    backgroundColor: "#ffffff",
                                    color: "#1a4bbd",
                                    textDecoration: "none",
                                    padding: "0",
                                    cursor: "pointer",
                                    transition: "all 0.2s"
                                }}
                            >
                                <i className="material-icons text-primary" style={{ fontSize: "20px", fontWeight: "bold" }}>arrow_back_ios</i>
                            </a>
                        </div>
                        <a href="#" className="w-100">
                            <div className="d-table m-auto">
                                <div className="logo-img">
                                    <img
                                        src={require("assets/img/logo192.png")}
                                        alt="logo_bomberos"
                                        style={{ width: "120px", height: "auto" }}
                                    />
                                </div>
                            </div>
                        </a>
                    </nav>
                </div>
                <div className="h-100">
                    <div className="nav-wrapper">
                        <ul className="nav--no-borders flex-column nav">
                            {/* DASHBOARD - Siempre visible o configurable */}
                            <li className="nav-item">
                                <NavLink
                                    onClick={navToggle}
                                    to="/dashboard"
                                    activeClassName="btn btn-active-menu btn-block text-primary"
                                    className={`btn btn-transparent btn-block ${`${url}`.includes("/dashboard") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                >
                                    <div className="d-flex align-items-center">
                                        <span className="material-icons">dashboard</span>
                                        <span className="content-sidebar-buttons">Dashboard</span>
                                    </div>
                                </NavLink>
                            </li>

                            <li className="nav-item">
                                <NavLink
                                    onClick={navToggle}
                                    to="/dashboard-open"
                                    activeClassName="btn btn-active-menu btn-block text-primary"
                                    className={`btn btn-transparent btn-block ${`${url}`.includes("/dashboard-open") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                >
                                    <div className="d-flex align-items-center">
                                        <span className="material-icons">assessment</span>
                                        <span className="content-sidebar-buttons">Dashboard Público</span>
                                    </div>
                                </NavLink>
                            </li>

                            {/* ESTACIONES */}
                            {hasPermission(user, 'stations', 'view') && (
                                <li className="nav-item">
                                    <NavLink
                                        to="/stations"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/stations") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                        onClick={navToggle}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="material-icons">location_city</span>
                                            <span className="content-sidebar-buttons">Estaciones</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}

                            {/* USUARIOS */}
                            {hasPermission(user, 'users', 'view') && (
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/users"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/users") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="material-icons">person</span>
                                            <span className="content-sidebar-buttons">Usuarios</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}

                            {/* TIPOS DE EMERGENCIA - Generalmente Admin */}
                            {hasPermission(user, 'emergencies', 'create') && ( // Si puede crear, prob. puede ver tipos
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/emergency-types"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/emergency-type") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="material-icons">format_list_numbered_rtl</span>
                                            <span className="content-sidebar-buttons">Tipos de Emergencia</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}

                            {/* EMERGENCIAS */}
                            {hasPermission(user, 'emergencies', 'view') && (
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/emergencies"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/emergencies") || `${url}`.includes("/emergency/") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="material-icons">settings_remote</span>
                                            <span className="content-sidebar-buttons">Emergencias</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}

                            {/* TIPOS DE VEHICULOS */}
                            {hasPermission(user, 'vehicles', 'create') && (
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/vehicle-types"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/vehicle-types") || `${url}`.includes("/vehicle-type") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="material-icons">format_list_numbered_rtl</span>
                                            <span className="content-sidebar-buttons">Tipos de Vehículos</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}

                            {hasPermission(user, 'predictive_analysis', 'view') && showPredictive && (
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/prediccion"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/prediccion") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <span className="material-icons">assessment</span>
                                        <span className="content-sidebar-buttons">Bomberos Predict</span>
                                    </NavLink>
                                </li>
                            )}

                            {/* TRACKING */}
                            {hasPermission(user, 'tracking', 'view') && (
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/tracking"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/tracking") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="material-icons">navigation</span>
                                            <span className="content-sidebar-buttons">Trackeo</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}

                            {/* VEHICULOS */}
                            {hasPermission(user, 'vehicles', 'view') && (
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/vehicles"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/vehicles") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="material-icons">bus_alert</span>
                                            <span className="content-sidebar-buttons">Vehículos</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}

                            {/* QR SCAN - Usando permiso específico o lógica de rol si no existe permiso */}
                            {(hasPermission(user, 'qr_scan', 'view') || [ROLE_ADMIN, ROLE_STATION_BOSS, ROLE_ADMIN_STATION, HUMAN_RESOURCES].includes(user.role)) && (
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/qr_scan"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/qr_scan") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <img
                                                className="qr-material-icons"
                                                style={{
                                                    filter: url.includes("/qr_scan")
                                                        ? "invert(24%) sepia(98%) saturate(1769%) hue-rotate(213deg) brightness(93%) contrast(89%)"
                                                        : "invert(48%) sepia(13%) saturate(399%) hue-rotate(174deg) brightness(92%) contrast(89%)"
                                                }}
                                                src={qr_code}
                                            />
                                            <span className="content-sidebar-buttons">Escaneo de QR</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}

                            {/* ROLES Y PERMISOS - Solo Admin o permiso específico */}
                            {hasPermission(user, 'roles', 'view') && (
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/roles"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/roles") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="material-icons">security</span>
                                            <span className="content-sidebar-buttons">Roles y Permisos</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}

                            {/* TIPOS DE ROL (SISTEMA) */}
                            {user.role === ROLE_ADMIN && (
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/system-roles"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/system-roles") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="material-icons">assignment_ind</span>
                                            <span className="content-sidebar-buttons">Roles de Sistema</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}
                            {/* NOTIFICATION CONFIG - Solo Admin */}
                            {user.role === ROLE_ADMIN && (
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/notification-config"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/notification-config") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="material-icons">notifications_active</span>
                                            <span className="content-sidebar-buttons">Config. Notificaciones</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}

                            {/* REPORTES */}
                            {hasPermission(user, 'reports', 'view') && (
                                <React.Fragment>
                                    <li className="dropdown-btn-reporting nav-item d-flex">
                                        <button className={`btn btn-block`} style={styleDropReport}>
                                            <div className="d-flex align-items-center">
                                                <span className="material-icons">folder_open</span>
                                                <span className="content-sidebar-buttons mr-auto">Reporteria</span>
                                                <span className="material-icons ml-2">expand_more</span>
                                            </div>
                                        </button>
                                    </li>
                                    <div className="dropdown-container">
                                        {(hasPermission(user, 'reports', 'human_resources') || [ROLE_ADMIN, HUMAN_RESOURCES].includes(user.role)) && (
                                            <Link
                                                onClick={navToggle}
                                                className={`mb-2 dropdown-show ${`${url}`.includes("/report/human_resources_report") ? "active-a" : ""}`}
                                                to="/report/human_resources_report"
                                            >
                                                Recursos Humanos
                                            </Link>
                                        )}

                                        <Link
                                            onClick={navToggle}
                                            className={`mb-2 dropdown-show ${`${url}`.includes("/report/emergency_report") ? "active-a" : ""}`}
                                            to="/report/emergency_report"
                                        >
                                            Emergencias
                                        </Link>
                                        <Link
                                            onClick={navToggle}
                                            className={`mb-2 dropdown-show ${`${url}`.includes("/report/emergency_detail_report") ? "active-a" : ""}`}
                                            to="/report/emergency_detail_report"
                                        >
                                            Reporte Detallado
                                        </Link>
                                        <Link
                                            onClick={navToggle}
                                            className={`mb-2 dropdown-show ${`${url}`.includes("/report/region_report") ? "active-a" : ""}`}
                                            to="/report/region_report"
                                        >
                                            Reporte Regional
                                        </Link>
                                    </div>
                                </React.Fragment>
                            )}
                            {user.role === 1 && (
                                <li className="nav-item">
                                    <NavLink
                                        onClick={navToggle}
                                        to="/binnacle"
                                        activeClassName="btn btn-active-menu btn-block text-primary"
                                        className={`btn btn-transparent btn-block ${`${url}`.includes("/binnacle") ? "text-primary btn-active-menu" : "text-secondary"}`}
                                    >
                                        <div className="d-flex align-items-center">
                                            <span className="material-icons">history</span>
                                            <span className="content-sidebar-buttons">Bitácora</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )}
                            {(user.role === 1 || user.role === 11) && (
                                <React.Fragment>
                                    <li className="dropdown-btn nav-item d-flex">
                                        <button
                                            className={`btn btn-block`}
                                            style={styleDrop}
                                        >
                                            <div className="d-flex align-items-center">
                                                <span className="material-icons">
                                                    group_add
                                                </span>
                                                <span className="content-sidebar-buttons mr-auto">
                                                    Recursos Humanos
                                                </span>
                                                <span className="material-icons ml-2">
                                                    expand_more
                                                </span>
                                            </div>
                                        </button>
                                    </li>
                                    <div className="dropdown-container">
                                        <Link
                                            onClick={navToggle}
                                            className={`mb-2 dropdown-show ${`${url}`.includes(
                                                "/human_resources/job_management"
                                            )
                                                ? "active-a"
                                                : ""
                                                }`}
                                            to="/human_resources/job_management"
                                        >
                                            Gestion De Puestos
                                        </Link>
                                        <Link
                                            onClick={navToggle}
                                            className={`mb-2 dropdown-show ${`${url}`.includes(
                                                "/human_resources/control_hours"
                                            )
                                                ? "active-a"
                                                : ""
                                                }`}
                                            to="/human_resources/control_hours"
                                        >
                                            Control De Horas
                                        </Link>
                                        <Link
                                            onClick={navToggle}
                                            className={`dropdown-show ${`${url}`.includes(
                                                "/human_resources/unsubscribe_discharge"
                                            )
                                                ? "active-a"
                                                : ""
                                                }`}
                                            to="/human_resources/unsubscribe_discharge"
                                        >
                                            Dar De Baja / Alta
                                        </Link>
                                    </div>
                                </React.Fragment>
                            )}
                        </ul>

                        {/* VERSION FOOTER */}
                        <div style={{
                            textAlign: 'center',
                            padding: '15px 20px',
                            marginTop: 'auto',
                            borderTop: '1px solid #f0f0f0'
                        }}>
                            <small style={{ color: '#1a4bbd', fontSize: '11px', fontWeight: '500' }}>v{APP_VERSION}</small>
                        </div>
                    </div>
                    <div
                        className="btn-white border"
                        style={{ margin: "10px 15px" }}
                    >
                        <Dropdown
                            direction="up"
                            isOpen={dropdownUserOpen}
                            toggle={() =>
                                setDropdownUserOpen(!dropdownUserOpen)
                            }
                        >
                            <DropdownToggle
                                color={"transparent"}
                                className="w-100"
                            >
                                <div className="d-flex flex-wrap">
                                    <div className="col-3">
                                        <div className="rounded-circle bg-white mr-1 align-middle d-inline-flex">
                                            <Avatar
                                                round
                                                size="35"
                                                name="Foo Bar"
                                                src={
                                                    user.photo
                                                        ? user.photo
                                                        : defaultAvatar
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-9 d-flex flex-column align-items-center justify-content-center">
                                        <span className="font-weight-bold">
                                            {user.first_name} {user.last_name}
                                        </span>
                                        <span className="text-primary font-weight-bold">
                                            {user.name_role}
                                        </span>
                                    </div>
                                </div>
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem tag="a" href="#/user-profile">
                                    <div
                                        onClick={navToggle}
                                        className="flex row mx-auto align-items-center py-0"
                                    >
                                        <i className="material-icons"></i>
                                        <p className="mb-0 mt-2">Perfil</p>
                                    </div>
                                </DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem tag="a" href="/" onClick={logOut}>
                                    <div className="flex row align-items-center py-0">
                                        <i className="material-icons text-danger">
                                            
                                        </i>
                                        <p className="mb-0 pt-1">
                                            Cerrar sesión
                                        </p>
                                    </div>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
            </aside>
        </React.Fragment >
    );
};

export default SideBar;
